export const BULK = {
  BULL_EXPORT_INTENDED_USE_LOAD_FAILED: 'Failed to load intended use',
  BULK_EXPORT_ITEM_TYPE_LOAD_FAILED: 'Failed to load item type',
}

export const BULK_UPDATE = {
  EXPORT_ITEM: {
    EXPORT_TITLE: 'Download Spreadsheet',
    EXPORT_OPTIONS: [
      { displayName: 'Template with available item data', value: 'all' },
      {
        displayName: 'Attribute Reference  (read-only)',
        value: 'readOnly',
      },
    ],
    PLACEHOLDER_INTENDED_USE: 'Select intended use',
    PLACEHOLDER_ITEM_TYPE: 'Select item type',
  },
  INSTRUCTIONS: {
    HEADER_TITLE: 'Instructions to Upload Item Data',
  },
  UPLOAD_SPREADSHEET: {
    HEADER_TITLE: 'Upload Spreadsheet',
    UPLOAD_CONSTRAINT: `File must be in XLS, XLSX or CSV format, not exceed 10 MB, and contain a maximum of 10,000 rows. 
Ensure you’re using the latest version of the template that supports LaunchPad, Compliance, and Pricing attributes.`,
    UPLOAD_ACTION_GUIDE: 'Drop your file here or click browse to select a file',
    FILESIZE: 10 * 1000000, // 10 MB
    ALLOWED_TYPES: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      '.xls,.xlsx,.csv',
    ],
    FILE_TYPE_ERROR: 'File must be in XLS, XLSX or CSV format.',
  },
}

export const BULK_DOWNLOAD_TOOLTIP = {
  NO_ITEMS_MESSAGE: 'No items available for setup or maintain',
  TEMPLATE_DEFAULT_MESSAGE:
    'Template v2.0 (includes Launchpad, Compliance & Pricing attributes)',
}
